import { TextInput, StatusTable, Row, SubmitBar, Loader, FormStep, CardLabel, RadioOrSelect } from "@egovernments/digit-ui-react-components";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import LandDevelopment from "./LandDevelopmentTable";
import KhasraArea from "./KhasraArea";

const PlotDetails = ({ formData, onSelect, config }) => {
  const { t } = useTranslation();
  const [khatauniNo, setKhatauniNo] = useState("");
  const [subdivision, setSubdivision] = useState(null);
  const [isClu, setIsClu] = useState(null);
  const [cluType, setcluType] = useState("");
  const [caserefNo, setCaseRefNo] = useState("");
  const [excaserefNo, setExCaseRefNo] = useState("");
  const [noOfPlot, setnoOfPlot] = useState("");
  const [appliedLand, setAppliedLand] = useState(null);
  const [propertyType, setPropertyType] = useState([]);
  const [proposal, setProposal] = useState(null);
  const [constructionType, setConstructionType] = useState(formData?.data?.occupancyType || "");
  const [areaforDevelopment, setPlotAreaforDevlopment] = useState("");
  const [totalKhasraArea, setTotalKhasraArea] = useState(0);
  let validation = {};

  const state = Digit.ULBService.getStateId();
  const { data, isLoading } = Digit.Hooks.obps.useScrutinyDetails(state, formData?.data?.scrutinyNumber);
  const plotArea = data?.planDetail?.planInformation?.plotArea || "";
  const typeofArea = data?.planDetail?.planInformation?.occupancy || "";
  const buildupArea = data?.planDetail?.virtualBuilding?.totalBuitUpArea || "";
  const [khasraArea, setKhasraArea] = useState([{ khasra: "", area: "" }]);
  const [landDevelopment, setLandDevelopment] = useState([{ plotNo: "", plotarea: "", landType: "" }]);
  function selectDivision(code) {
    setSubdivision(code);
  }
  function selectAppliedLand(code) {
    setAppliedLand(code);
  }
  const landOption = [
    { code: "Residential", i18nKey: "CS_COMMON_RESIDENTIAL" },
    { code: "Industrial", i18nKey: "CS_COMMON_INDUSTRIAL" },
    { code: "Commercial", i18nKey: "CS_COMMON_COMMERCIAL" },
    { code: "Public & SemiPublic", i18nKey: "CS_COMMON_PUBLIC" },
  ];
  const propertyTypeOptions = [
    { code: "Govt", i18nKey: "CS_COMMON_GOVT" },
    { code: "Private", i18nKey: "CS_COMMON_PRIVATE" },
    { code: "Public & SemiPublic", i18nKey: "CS_COMMON_PUBLIC" },
  ];
  const cluTypeOptions = [
    { code: "CLUfromOriginal", i18nKey: "CS_BPA_CHANGE_OF_LAND_USE_FROM_ORIGINAL" },
    { code: "IDPDevelopmentPlan", i18nKey: "IDP_DEVELOPMENT_PLAN_TO_OTHER_LAND_USE" },
  ];
  const proposalTypeOptions = [
    { code: "Approval of Fresh Building Plan", i18nKey: "CS_COMMON_FRESH_BUILDING_PLAN" },
    { code: "Change of Existing Building Use", i18nKey: "CS_COMMON_CHANGE_EXSISTING_BUILDING_USE" },
    { code: "Reconstruction of Old Line", i18nKey: "CS_COMMON_RECONSTRUCTION" },
    { code: "Alteration and Additional of Existing Building", i18nKey: "CS_COMMON_EXSISTING_BUILDING" },
    { code: "New Building Use", i18nKey: "CS_COMMON_NEW_BUILDING_USE" },
    { code: "Revised proposal of Approval Map", i18nKey: "CS_COMMON_PUBLIC_REVISED_MAP" },
  ];

  const handleKhasraChange = (e, index) => {
    const updatedKhasraArea = [...khasraArea];
    updatedKhasraArea[index].khasra = e.target.value;
    setKhasraArea(updatedKhasraArea);
  };
  const handlePlotChange = (e, index) => {
    const updatedPLotNo = [...landDevelopment];
    updatedPLotNo[index].plotNo = e.target.value;
    setLandDevelopment(updatedPLotNo);
  };
  const handlePlotAreaChange = (e, index) => {
    const updatedPLotArea = [...landDevelopment];
    updatedPLotArea[index].plotarea = e.target.value;
    setLandDevelopment(updatedPLotArea);
  };
  const handlePropertyTypeChange = (code, index) => {
    console.log({ code, index });
    const updatedLandDevelopment = [...landDevelopment];
    updatedLandDevelopment[index].landType = code?.code;
    setLandDevelopment(updatedLandDevelopment);
  };
  const handleAreaChange = (e, index) => {
    let totalArea = 0;
    const updatedKhasraArea = [...khasraArea];
    updatedKhasraArea[index].area = e.target.value;
    updatedKhasraArea.forEach((item) => {
      totalArea += parseInt(item.area);
    });
    setKhasraArea(updatedKhasraArea);
    setTotalKhasraArea(totalArea);
  };

  const addRow = () => {
    const index = khasraArea.length - 1;
    if (khasraArea?.[index]?.khasra?.length > 0 && khasraArea?.[index]?.area?.length > 0) {
      setKhasraArea([...khasraArea, { khasra: "", area: "" }]);
    } else {
      alert("Please add both the values");
    }
  };
  const addLandRow = () => {
    const index = landDevelopment.length - 1;
    if (
      landDevelopment?.[index]?.plotNo?.length > 0 &&
      landDevelopment?.[index]?.plotarea?.length > 0 &&
      landDevelopment?.[index]?.landType?.length > 0
    ) {
      setLandDevelopment([...landDevelopment, { plotNo: "", plotarea: "", landType: "" }]);
    } else {
      alert("Please add all the values");
    }
  };

  const deleteRow = (indexToDelete) => {
    const updatedKhasraArea = khasraArea.filter((_, index) => index !== indexToDelete);
    let totalArea = 0;
    updatedKhasraArea.forEach((item) => {
      totalArea += parseInt(item.area);
    });
    setKhasraArea(updatedKhasraArea);
    setTotalKhasraArea(totalArea);
  };
  const deleteLandRow = (ind) => {
    const updatedLandArea = landDevelopment.filter((_, index) => index !== ind);
    setLandDevelopment(updatedLandArea);
  };

  const handleSubmit = () => {
    const plotDetails = {};
    (plotDetails.khatauniNo = khatauniNo || ""),
      (plotDetails.subdivision = subdivision?.code || " "),
      (plotDetails.caserefNo = caserefNo || ""),
      (plotDetails.noOfPlot = noOfPlot || ""),
      (plotDetails.appliedLand = appliedLand?.code || ""),
      (plotDetails.propertyType = propertyType?.code || ""),
      (plotDetails.proposal = proposal?.code || ""),
      (plotDetails.constructionType = constructionType || ""),
      (plotDetails.areaforDevelopment = areaforDevelopment || "");
    plotDetails.plotArea = plotArea || "";
    plotDetails.typeofArea = typeofArea || "";
    plotDetails.totalBuildUpArea = buildupArea || "";
    plotDetails.khasraArea = khasraArea || [];
    plotDetails.totalKhasraArea = totalKhasraArea || 0;
    plotDetails.cluInvolved = isClu || null;
    plotDetails.cluType = cluType || null;
    plotDetails.landDevelopment = landDevelopment || [];
    plotDetails.exsistingCaseRefNo = excaserefNo || "";
    onSelect(config?.key, { ...plotDetails });
  };
  const onSkip = () => onSelect();

  if (isLoading) {
    return <Loader />;
  }
  const labelStyle = {
    fontWeight: "bold",
    fontSize: "1rem",
  };
  return (
    <div>
      <FormStep
        onSelect={handleSubmit}
        childrenAtTheBottom={false}
        t={t}
        _defaultValues={formData?.data}
        onSkip={onSkip}
        isDisabled={khatauniNo}
        cardStyle={{ boxShadow: "none", padding: 0, border: 0 }}
      >
        <StatusTable style={{ marginLeft: "13px" }}>
          <Row className="border-none" label={t(`BPA_BOUNDARY_PLOT_AREA_LABEL`)} text={plotArea ? `${plotArea} ${t(`SQMT`)}` : "N/A"} />
          <Row className="border-none" label={t(`BPA_PLOT_NUMBER_LABEL`)} text={data?.planDetail?.planInformation?.plotNo} />
          <Row className="border-none" label={t(`BPA_KHATHA_NUMBER_LABEL`)} text={data?.planDetail?.planInformation?.khataNo} />
          <Row className="border-none" label={t(`BPA_TYPE_OF_AREA_LABEL`)} text={typeofArea || "N/A"} />
          <Row className="border-none" label={t(`BPA_MAXIMUM_PERMISSIBLE_GROUND_COVERAGE`)} text={data?.planDetail?.coverage || "N/A"} />
          <Row
            className="border-none"
            label={t(`BPA_LAND_USE_LABEL`)}
            text={t(`BPA_LAND_USE_${data?.planDetail?.planInformation?.landUseZone}`) || "N/A"}
          />
          <Row
            className="border-none"
            label={t(`BPA_FAR_LABEL`)}
            text={data?.planDetail?.farDetails?.providedFar || data?.planDetail?.farDetails?.permissableFar || "N/A"}
          />
          <Row className="border-none" label={t(`BPA_BUILD_UP_AREA_LABEL`)} text={buildupArea} />
        </StatusTable>
        <div style={{ marginLeft: "13px" }}>
          <KhasraArea
            khasraArea={khasraArea}
            handleKhasraChange={handleKhasraChange}
            handleAreaChange={handleAreaChange}
            addRow={addRow}
            deleteRow={deleteRow}
            t={t}
          />
          <CardLabel style={labelStyle}>{`${t("BPA_PLOT_TOTAL_KHASRA_AREA_LABEL")}`}</CardLabel>
          <TextInput t={t} type={"text"} isMandatory={false} optionKey="i18nKey" name="totalKhasraArea" value={totalKhasraArea} disabled={true} />
          <CardLabel style={labelStyle}>{`${t("BPA_PLOT_KHATAUNI_NO_LABEL")}`}</CardLabel>
          <TextInput
            t={t}
            type={"text"}
            isMandatory={false}
            optionKey="i18nKey"
            name="khatauniNo"
            value={khatauniNo}
            onChange={(e) => setKhatauniNo(e.target.value)}
            {...(validation = {
              isRequired: true,
              pattern: "^[a-zA-Z-.`' ]*$",
              type: "text",
              title: t("PT_NAME_ERROR_MESSAGE"),
            })}
          />
          <CardLabel variant="h6" style={labelStyle}>{`${t("BPA_PLOT_WHEATHER_SUBDIVISION_APPROVED_LABEL")}`}</CardLabel>
          <RadioOrSelect
            optionKey="i18nKey"
            options={[
              { code: true, name: "yes", i18nKey: "CS_COMMON_YES" },
              { code: false, name: "no", i18nKey: "CS_COMMON_NO" },
            ]}
            onSelect={selectDivision}
            selectedOption={subdivision}
            t={t}
          />
          {subdivision?.code && (
            <div>
              <CardLabel variant="h6" style={labelStyle}>{`${t("BPA_PLOT_CASE_REFERENCE_NUMBER_LABEL")}`}</CardLabel>
              <TextInput
                t={t}
                type={"text"}
                isMandatory={false}
                optionKey="i18nKey"
                name="caserefNo"
                value={caserefNo}
                onChange={(e) => setCaseRefNo(e.target.value)}
                {...(validation = {
                  isRequired: true,
                  pattern: "^[a-zA-Z-.`' ]*$",
                  type: "text",
                  title: t("PT_NAME_ERROR_MESSAGE"),
                })}
              />
            </div>
          )}
          <CardLabel variant="h6" style={labelStyle}>{`${t("BPA_NO_OF_PLOT_LABEL")}`}</CardLabel>
          <TextInput
            t={t}
            type={"number"}
            isMandatory={false}
            optionKey="i18nKey"
            name="noOfPlot"
            value={noOfPlot}
            onChange={(e) => setnoOfPlot(e.target.value)}
            {...(validation = {
              isRequired: true,
              pattern: "^[a-zA-Z-.`' ]*$",
              type: "text",
              title: t("PT_NAME_ERROR_MESSAGE"),
            })}
          />
          <CardLabel style={labelStyle}>{`${t("BPA_APPLIED_ORIGINAL_LAND_USE")}`}</CardLabel>
          <RadioOrSelect
            name="appliedLand"
            optionKey="i18nKey"
            options={landOption}
            onSelect={selectAppliedLand}
            selectedOption={appliedLand}
            t={t}
          />
          <CardLabel variant="h6" style={labelStyle}>{`${t("BPA_PROPERTY_TYPE_LABEL")}`}</CardLabel>
          <RadioOrSelect
            name="propertyType"
            optionKey="i18nKey"
            options={propertyTypeOptions}
            onSelect={(code) => setPropertyType(code)}
            selectedOption={propertyType}
            t={t}
          />
          <CardLabel variant="h6" style={labelStyle}>{`${t("BPA_PROPOSAL_SUBMISSION_LABEL")}`}</CardLabel>
          <RadioOrSelect
            name="proposal"
            optionKey="i18nKey"
            options={proposalTypeOptions}
            onSelect={(code) => setProposal(code)}
            selectedOption={proposal}
            t={t}
          />
          {proposal?.code === "Revised proposal of Approval Map" && (
            <div>
              <CardLabel variant="h6" style={labelStyle}>{`${t("BPA_PLOT_EXSISTING_CASE_REFERENCE_NUMBER_LABEL")}`}</CardLabel>
              <TextInput
                t={t}
                type={"text"}
                isMandatory={false}
                optionKey="i18nKey"
                name="exsistingCaseRefNo"
                value={excaserefNo}
                onChange={(e) => setExCaseRefNo(e.target.value)}
                {...(validation = {
                  isRequired: true,
                  pattern: "^[a-zA-Z-.`' ]*$",
                  type: "text",
                  title: t("PT_NAME_ERROR_MESSAGE"),
                })}
              />
            </div>
          )}
          <CardLabel variant="h6" style={labelStyle}>{`${t("BPA_TYPE_OF_CONSTRUCTION_LABEL")}`}</CardLabel>
          <TextInput
            t={t}
            type={"number"}
            isMandatory={false}
            optionKey="i18nKey"
            name="constructionType"
            value={constructionType}
            onChange={(e) => setConstructionType(e.target.value)}
            {...(validation = {
              isRequired: true,
              pattern: "^[a-zA-Z-.`' ]*$",
              type: "text",
              title: t("PT_NAME_ERROR_MESSAGE"),
            })}
          />
          <CardLabel variant="h6" style={labelStyle}>{`${t("BPA_PLOT_AREA_FOR_DEVELOPMENT_LABEL")}`}</CardLabel>
          <TextInput
            t={t}
            type={"number"}
            isMandatory={false}
            optionKey="i18nKey"
            name="plotAreafordevelopment"
            value={areaforDevelopment}
            onChange={(e) => setPlotAreaforDevlopment(e.target.value)}
            {...(validation = {
              isRequired: true,
              pattern: "^[a-zA-Z-.`' ]*$",
              type: "text",
              title: t("PT_NAME_ERROR_MESSAGE"),
            })}
          />
          <CardLabel variant="h6" style={labelStyle}>{`${t("BPA_PLOT_WHEATHER_CHANGE_OF_LAND_USE_LABEL")}`}</CardLabel>
          <RadioOrSelect
            optionKey="i18nKey"
            options={[
              { code: true, name: "yes", i18nKey: "CS_COMMON_YES" },
              { code: false, name: "no", i18nKey: "CS_COMMON_NO" },
            ]}
            onSelect={(code) => setIsClu(code)}
            selectedOption={isClu}
            t={t}
          />
          {isClu?.code && (
            <div>
              <CardLabel variant="h6" style={labelStyle}>{`${t("BPA_CLU_TYPE_LABEL")}`}</CardLabel>
              <RadioOrSelect
                name="cluType"
                optionKey="i18nKey"
                options={cluTypeOptions}
                onSelect={(code) => setcluType(code)}
                selectedOption={cluType}
                t={t}
                isDropDown={true}
              />
            </div>
          )}
          {isClu?.code && cluType?.code && (
            <div>
              <CardLabel variant="h6" style={labelStyle}>{`${t("BPA_PLOT_DETAILS_AFTER_SUBDIVISION")}`}</CardLabel>
              <LandDevelopment
                landDevelopment={landDevelopment}
                handlePlotChange={handlePlotChange}
                handlePlotAreaChange={handlePlotAreaChange}
                handlePropertyTypeChange={handlePropertyTypeChange}
                addLandRow={addLandRow}
                deleteLandRow={deleteLandRow}
                propertyTypeOptions={landOption}
                t={t}
              />
            </div>
          )}
        </div>
        <SubmitBar label={t(`CS_COMMON_NEXT`)} onSubmit={handleSubmit} style={{ margin: "1rem" }} />
      </FormStep>
    </div>
  );
};

export default PlotDetails;
